(function () {
  var root = document.getElementById('bjaf-geo-market');
  if (!root) return;

  var STORAGE_KEY = 'bjaf_geo_stay_com_v1';
  var markets = {};
  try {
    markets = JSON.parse(root.getAttribute('data-markets') || '{}');
  } catch (e) {
    return;
  }

  var params = new URLSearchParams(location.search || '');
  var forceDemo = (params.get('bjaf_geo_demo') || '').toUpperCase();
  var forceShow = params.get('bjaf_geo_force') === '1';
  var iso = forceDemo || (window.Shopify && Shopify.country) || '';
  iso = String(iso).toUpperCase();
  var market = markets[iso];
  if (!market) return;

  function dismissed() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function rememberStay() {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* ignore */
    }
  }

  function hide() {
    root.hidden = true;
    document.documentElement.classList.remove('bjaf-geo-market-open');
  }

  function show() {
    root.hidden = false;
    document.documentElement.classList.add('bjaf-geo-market-open');
  }

  function onStay(event) {
    if (event) event.preventDefault();
    rememberStay();
    hide();
  }

  var host = (market.domain || '').replace(/^https?:\/\//, '');
  var path = root.getAttribute('data-path') || '/';
  var countryName = root.getAttribute('data-country-name') || iso;
  var title = root.querySelector('[data-bjaf-geo-title]');
  var body = root.querySelector('[data-bjaf-geo-body]');
  var go = root.querySelector('[data-bjaf-geo-go]');

  if (title) title.textContent = 'Looking for the ' + market.label + ' store?';
  if (body) {
    body.textContent =
      'You seem to be browsing from ' +
      countryName +
      '. You can switch to ' +
      host +
      ' for local pricing and content, or stay on bjaf.com.';
  }
  if (go) {
    go.href = market.domain.replace(/\/$/, '') + path;
    go.textContent = 'Go to ' + host;
  }

  root.setAttribute('data-iso', iso);
  root.setAttribute('data-domain', market.domain);

  if (!forceShow && !forceDemo && dismissed()) return;

  root.querySelectorAll('[data-bjaf-geo-stay]').forEach(function (el) {
    el.addEventListener('click', onStay);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !root.hidden) onStay(event);
  });

  show();
})();
